import {SPOTLIGHT_TEMPLATE_NAME, BLOGUE_TEMPLATE_NAME} from '../constants';
import {PageData} from "../types";

/**
 * Returns true when the pageData is a blog template.
 * Will check for the existance of 'post' on the pageData to detect old blog templates.
 * Will check for the _templateName field to match newer blog templates.
 * @param pageData The cms pageData
 */
export const isBlogTemplate = (pageData: PageData & {post: any;}): boolean => {
    if (!pageData || typeof pageData !== 'object') return false;
    let isBlogTemplate = false;
    if (pageData.post && typeof pageData.post === 'object') {
        isBlogTemplate = true;
    }
    if (
        pageData._templateName === SPOTLIGHT_TEMPLATE_NAME ||
        pageData._templateName === BLOGUE_TEMPLATE_NAME
    ) {
        isBlogTemplate = true;
    }

    return isBlogTemplate;
};
